import { clients } from '../../util/clients';

const { backendRest } = clients.direct;

export const dataBrowser = {
  namespaced: true,
  state: () => ({
    entries: [],
    currentPath: '',
    loading: false,
  }),
  mutations: {
    setEntries(state, { entries, path: p }) {
      state.entries = entries;
      state.currentPath = p;
    },
    setLoading(state, val) {
      state.loading = val;
    },
  },
  actions: {
    async fetchEntries({ commit, dispatch }, relPath = '') {
      commit('setLoading', true);
      try {
        await dispatch('reAuth', null, { root: true });
        const resp = await backendRest.get('/data-browser/list', { params: { path: relPath } });
        commit('setEntries', { entries: resp.data.entries, path: resp.data.path });
      } catch (e) {
        dispatch('logException', e, { root: true });
        dispatch('flashError', 'Failed to load directory listing.', { root: true });
      } finally {
        commit('setLoading', false);
      }
    },

    async downloadFile({ dispatch }, relPath) {
      try {
        await dispatch('reAuth', null, { root: true });
        const resp = await backendRest.get('/data-browser/download', {
          params: { path: relPath },
          responseType: 'blob',
        });
        const disposition = resp.headers['content-disposition'] || '';
        const match = disposition.match(/filename="(.+?)"/);
        const filename = match ? match[1] : relPath.split('/').pop();
        const url = URL.createObjectURL(resp.data);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        setTimeout(() => URL.revokeObjectURL(url), 10000);
      } catch (e) {
        dispatch('logException', e, { root: true });
        dispatch('flashError', 'Download failed.', { root: true });
      }
    },
  },
};

export default dataBrowser;
